import Reveal from "@/components/Reveal";

export const STAGES = [
  { n: "Research", t: "Understand before recommending", d: "Market, customer and business context come first. We do not propose a fix until we know what the evidence says." },
  { n: "Diagnose", t: "Find the real bottleneck", d: "The visible symptom is rarely the cause. We isolate what is actually constraining growth or operations." },
  { n: "Execute", t: "Allocate resources and own delivery", d: "Platforms, visibility and talent are deployed against the diagnosis, under one accountable owner." },
  { n: "Optimise", t: "Measure, refine, repeat", d: "What we learn feeds the next cycle of research, so the operating layer improves rather than ages." },
];

const COLORS = ["var(--arm-hop)", "#5b4bd6", "var(--arm-ae)", "var(--arm-ak)"];

export default function ProcessLoop({ dark = false, stacked = false }) {
  return (
    <Reveal>
      <ol className={`relative grid grid-cols-1 ${stacked ? "gap-0" : "md:grid-cols-4 gap-10 md:gap-6"}`} data-testid="process-loop">
        {/* horizontal track (desktop) */}
        <div className={`${stacked ? "hidden" : "hidden md:block"} absolute left-0 right-0 top-[19px] h-[3px] bg-slate-200/70`} aria-hidden="true">
          <div className="hp-draw h-full" style={{ background: "linear-gradient(90deg,var(--arm-hop),#5b4bd6,var(--arm-ae),var(--arm-ak))" }} />
        </div>
        {/* vertical track (mobile) */}
        <div className={`${stacked ? "" : "md:hidden"} absolute left-[18px] top-2 bottom-2 w-[3px] bg-slate-200/70`} aria-hidden="true" />
        {STAGES.map((s, i) => (
          <li key={s.n} className={`relative ${stacked ? "pl-14 py-9 lg:min-h-[34vh]" : "pl-14 md:pl-0"}`}>
            <span className={`absolute left-0 ${stacked ? "top-9" : "top-0 md:static"} flex h-10 w-10 items-center justify-center rounded-full text-white text-sm font-bold ring-4 ring-white`}
              style={{ background: COLORS[i] }} aria-hidden="true">{i + 1}</span>
            <h3 className={`font-display text-2xl font-semibold ${stacked ? "mt-0" : "mt-0 md:mt-5"} ${dark ? "text-white" : "text-hop-blue"}`}>{s.n}</h3>
            <p className={`mt-1 text-[15px] font-bold`} style={{ color: dark ? "#fff" : COLORS[i] }}>{s.t}</p>
            <p className={`mt-2 text-[15px] leading-relaxed ${dark ? "text-slate-300" : "hp-body"}`}>{s.d}</p>
          </li>
        ))}
      </ol>
      <p className={`mt-10 text-sm ${dark ? "text-slate-400" : "text-slate-500"}`}>
        Optimisation does not end the engagement. It reopens research with better evidence.
      </p>
    </Reveal>
  );
}
